import { useCallback, useState } from 'react'

import { Page } from '@/components/layout/page/page.tsx'
import { useFetchTeamTable } from '@/modules/team/hooks/use-fetch-team-table'
import { TeamMemberInviteDialog } from '@/modules/team/ui/dialogs/team-invite-dialog'
import { HeaderButtons } from '@/modules/team/ui/members/list/header-buttons'
import { TeamPageSkeleton } from '@/modules/team/ui/team-page-skeleton'
import { TeamTable } from '@/modules/team/views/team-table'

export const TeamView = () => {
  const [showInviteDialog, setShowInviteDialog] = useState(false)
  const [filter, setFilter] = useState('')

  const { data, isFetching } = useFetchTeamTable()

  const handleInviteMembersClick = useCallback(() => {
    setShowInviteDialog(true)
  }, [])

  if (isFetching || !data) {
    return <TeamPageSkeleton />
  }

  return (
    <Page
      title="Team"
      headerOptions={
        <HeaderButtons
          onFilterChange={setFilter}
          onInviteMembers={handleInviteMembersClick}
        />
      }
    >
      <TeamTable
        searchQuery={filter}
        data={data}
      />

      <TeamMemberInviteDialog
        showInviteDialog={showInviteDialog}
        setShowInviteDialog={setShowInviteDialog}
      />
    </Page>
  )
}
